import { Component, OnInit } from '@angular/core';
import { DashboardService } from '@service/dashboard.service';
import { ToasterLibraryService } from '@service/index';

@Component({
    selector: 'app-client-churn-widget',
    templateUrl: './client-churn-widget.component.html',
    styleUrls: ['./client-churn-widget.component.scss']
})
export class ClientChurnWidgetComponent implements OnInit {
    public isLoaded = false;
    public churnData: Array<any> = [];

    constructor(
        private dashboardService: DashboardService,
        private toasterLibrary: ToasterLibraryService
    ) { }

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.isLoaded = false;
        this.dashboardService.getChurn().subscribe(
            (res: any) => {
                if (res && res.data && Array.isArray(res.data)) {
                    this.churnData = res.data.slice(-6);
                } else if (Array.isArray(res)) {
                    this.churnData = res.slice(-6);
                }
                this.isLoaded = true;
            },
            (err: any) => {
                this.toasterLibrary.error(null, err?.error?.message || 'Failed to load churn data');
                this.isLoaded = true;
            }
        );
    }

    netClass(net: number): string {
        if (net > 0) { return 'text-success'; }
        if (net < 0) { return 'text-danger'; }
        return '';
    }
}